import styled from "styled-components";
import { tokens } from "../../public/tokens";

/**
 * Lays out a row of buttons (e.g. Save/Cancel) with a consistent gap between them.
 * Purely presentational - drop any `Button`/`PositiveButton`/`NegativeButton` inside.
 */
const ButtonGroup = styled.div({
    display: "flex",
    alignItems: "center",
    gap: tokens.globals["spacing-2-5"],
});

export default ButtonGroup;
